/**
 *
 * @param {*} key
 * @param {*} item
 */
export const setItem = (key, item, hashCode, expiresIn = 86400000) => {
    try {
        if (isLocalStorage()) {
            const now = new Date()
            // `itemObj` is an object which contains the original value
            // as well as the time when it's supposed to expire
            // hashCode is a string which is from the DOM Script Tag
            const itemObj = {
                item,
                expiry: now.getTime() + expiresIn, // 1 day = 86400000 milliseconds
                hashCode,
            }
            localStorage.setItem(key, JSON.stringify(itemObj))
        }
    } catch (error) {
        // Nothing to return
    }
}
/**
 *
 * @param {*} key
 */
export const isItemExist = key => {
    if (isLocalStorage()) {
        if (localStorage.getItem(key)) return true
        return false
    }
}
/**
 *
 * @param {*} key
 */
export const getItem = (key, hashCode) => {
    try {
        if (isLocalStorage()) {
            const itemStr = localStorage.getItem(key)
            // if the item doesn't exist, return null
            if (!itemStr) {
                return {
                    item: null,
                    hashCode,
                }
            }
            const item = JSON.parse(itemStr)
            const now = new Date()
            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry || item.hashCode !== hashCode) {
                // If the item is expired, delete the item from storage
                // and return null
                localStorage.removeItem(key)
                return {
                    item: null,
                    hashCode,
                }
            }
            return item
        }
    } catch (error) {
        return {
            item: null,
            hashCode,
        }
    }
}
/**
 *
 * @param {*} key
 */
export const removeItem = key => {
    if (isLocalStorage()) {
        localStorage.removeItem(key)
    }
}
/**
 *
 */
export const clearItems = () => {
    if (isLocalStorage()) {
        localStorage.clear()
    }
}
/**
 *
 */
export const isSessionStorage = () => {
    if (sessionStorage) return true
    return false
}
/**
 *
 */
export const isLocalStorage = () => {
    if (localStorage) return true
    return false
}
/**
 *
 * @param {*} key
 */
export const isKeyExist = key => {
    if (isLocalStorage()) {
        const keys = Object.keys(localStorage)
        for (const _key of keys) {
            if (_key == key) {
                return true
            }
        }
    }
    return false
}
/**
 * getHashFromDOMScriptTag - To get the Hash code from the DOM script tag
 * @returns the hashCode as string
 */
export const getHashFromDOMScriptTag = () => {
    try {
        const scriptTags = document.getElementsByTagName('script')
        let hashCode = null
        for (let i = scriptTags.length - 1; i >= 0; i--) {
            const srcPath = scriptTags[i].src
            if (srcPath) {
                let startIndex = srcPath.indexOf('/js/main.')
                if (startIndex >= 0) {
                    startIndex += 9
                    const endIndex = srcPath.indexOf('.chunk.js')
                    hashCode = srcPath.substring(startIndex, endIndex)
                    break
                }
            }
        }
        return hashCode
    } catch (error) {
        return null
    }
}
/**
 * getItemIfHashCodeMatches - To get the localStorage item using the key passed if it matches with the existing HashCode
 * @param {*} key
 * @returns the response as Object which includes the item and HashCode
 */
export const getItemIfHashCodeMatches = key => {
    const hashCode = getHashFromDOMScriptTag()
    const response = getItem(key, hashCode)
    return response
}
